import React from 'react';
import MUIDataTable from 'mui-datatables';
import DoNotDisturbUpdateForm from './DoNotDisturbUpdateForm';

import Moment from 'react-moment';

class DoNotDisturbDataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.data
    };
  }

  render() {
    const columns = [
      {
        name: 'personFirstName',
        label: 'First Name',
        options: {
          filter: true
        }
      },
      {
        name: 'personLastName',
        label: 'Last Name',
        options: {
          filter: true
        }
      },
      {
        name: 'excludedEmail',
        label: 'Email Address',
        options: {
          filter: true
        }
      },
      {
        name: 'excludedEmailCreateDate',
        label: 'Excluded date',
        options: {
          filter: true,
          customBodyRender: value => {
            return <Moment format='MMMM Do YYYY, h:mm a'>{value}</Moment>;
          }
        }
      },
      {
        name: 'excludedEmailLastUpdateDate',

        label: 'Updated date',
        options: {
          filter: true,
          customBodyRender: value => {
            return <Moment format='MMMM Do YYYY, h:mm a'>{value}</Moment>;
          }
        }
      },

      {
        name: 'excludedEmailId',
        label: 'Active Exclusions',
        options: {
          filter: false,
          customBodyRender: value => {
            return <DoNotDisturbUpdateForm id={value} />;
          }
        }
      }
    ];

    const data = this.state.items;

    const options = {
      filter: true,
      selectableRows: 'none',
      selectableRowsOnClick: false,
      filterType: 'multiselect',
      responsive: 'stacked',
      rowsPerPage: 10,
      viewColumns: false,
      rowsPerPageOptions: [5, 10, 15, 100],
    };

    return (
      <MUIDataTable
        title={'Search by name'}
        data={data}
        columns={columns}
        options={options}
      />
    );
  }
}

export default DoNotDisturbDataTable;
